<template>
  <v-app>
    <v-container fluid>
      <v-form
        @submit.prevent="submitForm(currentStatus)"
        ref="addPurOrder"
        id="addPurOrder"
      >
        <v-row v-if="$insertAccess($route.path)">
          <v-col md="3" cols="12">
            <v-expansion-panels v-model="panel">
              <v-expansion-panel>
                <v-expansion-panel-title
                  color="blue-grey-lighten-4"
                  class="panel-header"
                  >Others Info</v-expansion-panel-title
                >
                <v-expansion-panel-text>
                  <v-row class="pa-2">
                    <v-col cols="12">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="Proposal Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="proposal_date.value.value"
                        :error-messages="proposal_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>

                      <v-text-field
                        density="compact"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="ref_no.value.value"
                        :error-messages="ref_no.errorMessage.value"
                        autocomplete="off"
                        :disabled="false"
                        clearable
                      >
                        <template #label>
                          Ref No
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-text-field>

                       <v-autocomplete
                        label="Proposal Status"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="proposal_status_id.value.value"
                        :items="getSalesProposalStatus"
                        :item-title="(item) => item.name"
                        item-value="id"
                        :error-messages="proposal_status_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                        :disabled="!isEntryMode">
                          <template #label>
                            Proposal Status
                            <span class="text-red-accent-4">*</span>
                          </template>
                      </v-autocomplete>

                      <v-autocomplete
                        label="Lead"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="lead_id.value.value"
                        :items="getSalesLeads"
                        :item-title="(item) => `${item.code} - ${item.company_name}`"
                        item-value="id"
                        @update:modelValue="onLeadChange"
                        :error-messages="lead_id.errorMessage.value"
                        :disabled="isEntryMode == false"
                        autocomplete="off"
                        clearable
                      ></v-autocomplete>

                      <v-autocomplete
                        label="Customer"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="customer_id.value.value"
                        :items="getCustomerMapList"
                        :item-title="
                          (item) => item.customer ? `${item.customer.code} - ${item.customer.name}` : ''"
                        item-value="id"
                        @update:modelValue="onCustomerChange"
                        :error-messages="customer_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-autocomplete>

                      <v-text-field
                        density="compact"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="company_name.value.value"
                        :error-messages="company_name.errorMessage.value"
                        autocomplete="off"
                        :disabled="false"
                        clearable
                      >
                        <template #label>
                          Company Name
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-text-field>

                      <v-text-field
                        density="compact"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="contact_name.value.value"
                        :error-messages="contact_name.errorMessage.value"
                        autocomplete="off"
                        :disabled="false"
                        clearable
                      >
                        <template #label>
                          Contact Name
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-text-field>

                      <v-text-field
                        density="compact"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="contact_designation.value.value"
                        :error-messages="contact_designation.errorMessage.value"
                        autocomplete="off"
                        :disabled="false"
                        clearable
                      >
                        <template #label>
                          Contact Designation
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-text-field>

                      <v-text-field
                        label="Company Email"
                        density="compact"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="company_email.value.value"
                        :error-messages="company_email.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          Company Email
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-text-field>

                      <v-text-field
                        label="Company Mobile"
                        density="compact"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="company_phone.value.value"
                        :error-messages="company_phone.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          Company Phone
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-text-field>

                      <v-text-field
                        label="Company Website"
                        density="compact"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="company_website.value.value"
                        :error-messages="company_website.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-text-field>

                      <v-textarea
                        label="Company Address"
                        density="compact"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="company_address.value.value"
                        :error-messages="company_address.errorMessage.value"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          Company Address
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-textarea>

                      <v-autocomplete
                        label="Company Country"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="company_country_id.value.value"
                        :items="getInvCountryList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :error-messages="company_country_id.errorMessage.value"
                        autocomplete="off"
                        :menu-props="{ width: 300 }"
                        clearable
                      >
                        <template #label>
                          Company Country
                          <span class="text-red-accent-4">*</span>
                        </template>
                        <template v-slot:selection="{ props, item }">
                          <div class="d-flex align-center noto-color-emoji-regular"
                              v-bind="props"
                              color="primary"
                              variant="tonal"
                          >
                            <span class="mr-1">{{ item.raw.emoji }}</span>
                            {{ item.raw.name }}
                          </div>
                        </template>
                        <template v-slot:item="{ props, item }">
                          <v-list-item v-bind="props" v-slot=""  :title="null">
                              <div class="d-flex align-center noto-color-emoji-regular" style="width: 100%;">
                                  <span class="mr-2 text-lg">{{ item.raw.emoji }}</span>
                                  <div class="flex-grow-1">
                                      <span>{{ item.raw.name }}</span>
                                      <small v-if="item.raw.native" class="text-grey">
                                          ({{ item.raw.native }})
                                      </small>
                                  </div>
                                  <div class="text-grey text-caption">
                                      +{{ item.raw.phonecode }}
                                  </div>
                              </div>
                          </v-list-item>
                        </template>
                      </v-autocomplete>

                      <v-text-field
                        label="Company Nature of Business"
                        density="compact"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="company_nature_of_business.value.value"
                        :error-messages="
                          company_nature_of_business.errorMessage.value
                        "
                        autocomplete="off"
                        clearable
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>

          <v-col md="9" cols="12">
            <v-expansion-panels v-model="panel1">
              <v-expansion-panel>
                <v-expansion-panel-title
                  color="blue-grey-lighten-4"
                  class="panel-header"
                  >Item Info</v-expansion-panel-title
                >
                <v-expansion-panel-text>
                  <v-row class="pt-2 justify-center">
                    <v-col cols="8">
                      <v-autocomplete
                        label="Search Product Name"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="product_id.value.value"
                        :items="getProductMapList"
                        :item-title="(item) => `${item.product.code}-${item.product.name}` ?? 'N/A'"
                        item-value="product_id"
                        :error-messages="product_id.errorMessage.value"
                        @update:model-value="addCart"
                        @keydown.enter="addCart"
                        autocomplete="off"
                        clearable
                      ></v-autocomplete>

                      <input
                        v-model="pur_order_master_id.value.value"
                        type="hidden"
                      />
                    </v-col>

                    <!-- <v-col cols="1">
                      <v-btn class="bg-primary" @click="addCart">ADD</v-btn>
                    </v-col> -->
                  </v-row>

                  <!-- Cart Table -->
                  <v-row class="pt-0">
                    <v-col cols="12">
                      <!-- <v-table density="compact" :loading="loading" fixed-header class="table-dotted-border-bottom" style="height:40vh; overflow-y: scroll;"> -->
                      <v-table
                        density="compact"
                        :loading="loading"
                        fixed-header
                        class="table-dotted-border-bottom"
                      >
                        <!-- style="height:40vh; overflow-y: scroll;" -->
                        <thead>
                          <tr>
                            <th class="text-center" style="width: 5%">SL</th>

                            <th class="text-left" style="width: 25%">
                              Product Name
                            </th>

                            <th class="text-center" style="width: 10%">Code</th>
                            <th class="text-center" style="width: 10%">Unit</th>

                            <th class="text-center" style="width: 5%">
                              Quantity
                            </th>

                            <th class="text-center" style="width: 20%">
                              Price
                            </th>

                            <th class="text-center" style="width: 15%">
                              Amount
                            </th>

                            <th class="text-right" style="width: 5%">Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr
                            v-for="(item, index) in cart"
                            v-if="cart.length > 0"
                            :key="index"
                          >
                            <td class="text-center py-1">{{ index + 1 }}</td>

                            <td
                              class="text-left py-1"
                              style="white-space: normal"
                            >
                              <p style="width: 100px;">{{ item.product_name }}</p>
                            </td>

                            <td
                              class="text-left py-1"
                              style="white-space: normal"
                            >
                              {{ item.product_code }}
                            </td>

                            <td class="text-center py-1">
                              {{ item.unit_name }}
                            </td>

                            <td class="text-right py-1">
                              <v-text-field
                                :reverse="false"
                                controlVariant="stacked"
                                style="width: 80px"
                                label=""
                                type="number"
                                :hideInput="false"
                                :inset="false"
                                :min="1"
                                density="compact"
                                variant="outlined"
                                bg-color="grey-lighten-4"
                                v-model="item.qty"
                                hide-details
                                :error="item.qty < 1"
                                :error-messages="
                                  item.qty < 1
                                    ? 'Quantity must be greater than 0'
                                    : ''
                                "
                                @update:model-value="
                                  item.total = item.qty * item.sale_rate"
                                @blur="item.total = item.qty * item.sale_rate"
                              ></v-text-field>
                            </td>

                            <td class="text-center py-1">
                              <v-number-input
                              hide-details
                              density="compact"
                              controlVariant="hidden"
                              variant="outlined"
                              style="width: 120px"
                              v-model="item.sale_rate"
                              bg-color="grey-lighten-4"
                              :error="item.sale_rate < 1"
                              :error-messages="
                                item.sale_rate < 1
                                  ? 'Quantity must be greater than 0'
                                  : ''
                              "
                              @update:model-value="
                                item.total = item.qty * item.sale_rate
                              "
                              @blur="item.total = item.qty * item.sale_rate"
                              >
                              </v-number-input>
                              
                            </td>

                            <td class="text-center py-1">
                              {{ this.$numberFormat(item.total) }}
                            </td>

                            <td class="text-center py-1">
                              <v-icon
                                size="small"
                                color="red"
                                class="delete-button"
                                @click="removeFromCart(index)"
                              >
                                mdi-delete
                              </v-icon>
                            </td>
                          </tr>

                          <tr v-else-if="loading == true">
                            <td colspan="6" class="text-center">
                              <v-skeleton-loader
                                type="heading"
                                :loading="loading"
                              />
                            </td>
                          </tr>

                          <tr v-else>
                            <td colspan="6" class="text-center text-red">
                              You have no item
                            </td>
                          </tr>
                        </tbody>
                        <tfoot v-if="cart.length > 0">
                          <tr class="bg-grey-lighten-1">
                            <td
                              colspan="3"
                              class="text-right py-1"
                            >
                              Sub Total
                            </td>

                            <td
                              colspan="3"
                            ></td>

                            <td
                              class="text-center py-1"
                            >
                              {{ this.$numberFormat(subTotal) }}
                            </td>

                            <td
                              colspan="2"
                              class="bg-grey-lighten-1 text-center py-1"
                            ></td>
                          </tr>

                          <tr>
                            <td colspan="3" class="text-right py-1">
                              Discount (10 or 10%)
                            </td>

                            <td></td>
                            <td></td>

                            <td colspan="1" class="text-right py-1">
                              <v-text-field
                                v-model="discount_per.value.value"
                                density="compact"
                                label="%"
                                hide-details
                                dense
                                autocomplete="off"
                                variant="outlined"
                              />
                            </td>

                            <td class="text-center">
                              {{ this.$numberFormat(discountAmount) }}
                            </td>

                            <td colspan="1" class="text-center py-1"></td>
                          </tr>
                          <tr>
                            <td colspan="3" class="text-right py-1">
                              Tax (10 or 10%)
                            </td>
                            <td></td>
                            <td colspan="1" class="text-right py-1">
                              <v-select
                                v-model="taxType"
                                density="compact"
                                variant="outlined"
                                :items="includeOrExclude"
                                item-title="label"
                                item-value="value"
                                hide-details
                                style="max-width: 115px"
                              ></v-select>
                            </td>

                            <td colspan="1" class="text-right py-1">
                              <v-text-field
                                v-model="tax_per.value.value"
                                density="compact"
                                label="%"
                                hide-details
                                autocomplete="off"
                                variant="outlined"
                              />
                            </td>

                            <td class="text-center">
                              {{ this.$numberFormat(taxAmount) }}
                            </td>
                            <td class="text-center py-1"></td>
                          </tr>

                          <tr>
                            <td colspan="3" class="text-right py-1">
                              Vat (10 or 10%)
                            </td>

                            <td></td>

                            <td colspan="1" class="text-right py-1">
                              <v-select
                                variant="outlined"
                                density="compact"
                                v-model="vatType"
                                :items="includeOrExclude"
                                item-title="label"
                                item-value="value"
                                hide-details
                                style="width: 115px"
                              ></v-select>
                            </td>

                            <td colspan="1" class="text-right py-1">
                              <v-text-field
                                v-model="vat_per.value.value"
                                density="compact"
                                label="%"
                                hide-details
                                dense
                                autocomplete="off"
                                variant="outlined"
                              />
                            </td>

                            <td class="text-center">
                              {{ this.$numberFormat(vatAmount) }}
                            </td>
                            <td class="text-center py-1"></td>
                          </tr>

                          <tr>
                            <td colspan="3" class="text-right py-1">
                              Grand Total
                            </td>
                            <td colspan="1"></td>
                            <td colspan="2" class="text-right py-1"></td>
                            <td class="text-center py-1">
                              {{ this.$numberFormat(grandTotal) }}
                            </td>
                            <td></td>
                          </tr>
                        </tfoot>
                      </v-table>
                    </v-col>
                  </v-row>
                  <!-- Close Cart Table -->

                  <v-divider></v-divider>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>

            <v-expansion-panels v-model="panel2" class="pt-2">
              <v-expansion-panel>
                <v-expansion-panel-title
                  color="blue-grey-lighten-4"
                  class="panel-header"
                  >Letter Info</v-expansion-panel-title
                >
                <v-expansion-panel-text>
                  <v-col cols="12" class="pa-0">
                    <v-col>
                      <v-label class="text-subtitle-1 font-weight-bold mb-1">
                        Letter Subject
                        <span class="text-red-accent-4 ml-1">*</span>
                      </v-label>
                      <v-text-field
                        label="Subject"
                        class="visually-hidden-label"
                        density="compact"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="subject.value.value"
                        :error-messages="subject.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-text-field>
                    </v-col>

                    <v-col>
                      <v-label class="text-subtitle-1 font-weight-bold mb-1"
                        >Letter Body</v-label
                      >
                      <Ckeditor
                        :editor="ClassicEditor"
                        v-model="letter_body.value.value"
                        :config="editorConfig"
                      />
                    </v-col>

                    <v-col>
                      <v-label class="text-subtitle-1 font-weight-bold mb-1"
                        >Description</v-label
                      >
                      <Ckeditor
                        :editor="ClassicEditor"
                        v-model="letter_description.value.value"
                        :config="editorConfig"
                      />
                    </v-col>
                  </v-col>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
            <!-- <v-row class="d-flex justify-end px-5 mt-2">
              <v-checkbox
                :true-value="1"
                :false-value="0"
                v-model="status.value.value"
                label="Active"
                color="primary"
              ></v-checkbox>
            </v-row> -->
            <v-card-actions class="bg-white">
              <v-row class="pt-2 d-flex justify-end">
                <!-- <v-col cols="8">
                  <v-label class="text-subtitle-1 font-weight-bold mb-1">Description</v-label>
                  <v-textarea label="Description" class="visually-hidden-label" density="compact" variant="outlined"
                    bg-color="grey-lighten-4" v-model="remarks.value.value" :error-messages="remarks.errorMessage.value"
                    autocomplete="off" rows="3" clearable></v-textarea>
                </v-col> -->

                <v-col cols="4">
                  <v-layout class="justify-end">
                    <v-btn
                      class="bg-grey-darken-1 me-2"
                      variant="flat"
                      @click="submitForm(0)"
                      >DRAFT</v-btn
                    >

                    <v-btn
                      class="bg-primary"
                      variant="flat"
                      @click="submitForm(1)"
                      >POST</v-btn
                    >
                  </v-layout>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </v-app>
</template>

<script>
import { Ckeditor } from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import { getCurrentInstance, ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

import { useField, useForm } from "vee-validate";
import * as yup from "yup";

import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";

export default {
  components: {
    Ckeditor,
  },
  data: () => ({
    panel: [0],
    panel1: [0],
    panel2: [0],
    isEntryMode: true,
    loading: false,
    errorMessages: "",
    visible: false,
    vatType: 1,
    taxType: 1,
    types: [
      { id: 1, name: "Normal" },
      { id: 2, name: "Urgent" },
    ],
    includeOrExclude: [
      { value: 1, label: "Include" },
      { value: 2, label: "Exclude" },
    ],
  }),
  watch: {
    // getPurLetterInfo: {
    //   handler() {
    //     this.setLetterData();
    //   },
    //   immediate: true,
    // },
  },
  created() {
    if (this.$store.getters.getProductMapList.length === 0) {
      this.$store.dispatch("getProductMapList");
    }

    if (this.$store.getters.getCustomerMapList.length == 0) {
      this.$store.dispatch("getCustomerMapList");
    }

    if (this.$store.getters.getSalesProposalStatus.length === 0) {
      this.$store.dispatch("getSalesProposalStatus");
    }

    // if (this.$store.getters.getSalesLeads.length === 0) {
      this.$store.dispatch("getSalesLeads", { lock: 0, lead_status_id: 5 });
    // }

    if (this.$store.getters.getInvCountryList.length === 0) {
      this.$store.dispatch("getInvCountryList");
    }
    if (this.$store.getters.getPurLetterInfo.length === 0) {
      this.$store.dispatch("getPurLetterInfo");
    }
  },
  computed: {
    subTotal() {
      return this.cart.reduce((sum, item) => +sum + +item.total, 0);
    },

    discountAmount() {
      if (!this.discount_per?.value?.value) return 0;

      const val = this.discount_per.value.value.toString().trim();

      // If value ends with %, treat it as percentage
      if (val.endsWith("%")) {
        const percentage = parseFloat(val.replace("%", ""));
        return (this.subTotal * percentage) / 100 || 0;
      }

      // Otherwise treat it as flat discount
      return parseFloat(val) || 0;
    },

    taxAmount() {
      if (!this.tax_per.value.value) return 0;
      else {
        const val = this.tax_per.value.value.toString().trim();
        return (this.subTotal * val) / 100 || 0;
      }
    },

    vatAmount() {
      if (!this.vat_per.value.value) return 0;
      else {
        const val = this.vat_per.value.value.toString().trim();
        return (this.subTotal * val) / 100 || 0;
      }
    },

    grandTotal() {
      const discount = this.discountAmount;
      const vat = this.vatType === 1 ? this.vatAmount : 0;
      const tax = this.taxType === 1 ? this.taxAmount : 0;
      return this.subTotal - discount + vat + tax;
    },

    branchId() {
      return this.$store.getters.getAuthUser.branch_id || null;
    },

    getProductMapList() {
      let products = this.$store.getters.getProductMapList;
      return products.filter(
        (item) => item.branch_id == this.branchId && item.status == 1
      );
    },

    getCustomerMapList() {
      return this.$store.getters.getCustomerMapList;
    },

    getSalesProposalStatus() {
      return this.$store.getters.getSalesProposalStatus;
    },

    getSalesLeads() {
      return this.$store.getters.getSalesLeads;
    },

    getInvCountryList() {
      return this.$store.getters.getInvCountryList;
    },
    getPurLetterInfo() {
      const letterInfo = this.$store.getters.getPurLetterInfo;
      return letterInfo?.data?.[0] || {};
    },
  },
  methods: {
    setLetterData() {
      const data = this.getPurLetterInfo;
      console.log(this.getPurLetterInfo)
      if (data) {
        this.subject.value.value = data.subject || "";
        this.letter_description.value.value = data.terms || "";
        this.letter_body.value.value = data.regards || "";
      }
    },
    addCart() {
      let cartInd = this.cart.findIndex(
        (p) => p.product_id == this.product_id.value.value
      );

      if (this.product_id.value.value == null) {
        toast.error("Please select a Product");
        this.cartReset();
        return false;
      }

      if (cartInd > -1) {
        toast.error("Product already added in cart");
        this.cartReset();
        return false;
      }

      let product = this.getProductMapList.find(
        (item) => item.product_id == this.product_id.value.value
      );

      product = product.product;

      let item = {
        product_id: this.product_id.value.value,
        product_name: product.name,
        product_code: product.code,
        qty: 1,
        unit_id: product.unit_id,
        unit_name: product.unit.name,
        purchase_rate: product.purchase_rate,
        sale_rate: product.sale_rate,
        total: product.sale_rate * 1,
      };

      this.cart.push(item);
      this.$nextTick(() => {
        this.cartReset();
      });
    },

    removeFromCart(index) {
      if (confirm("Are You Sure?")) {
        this.cart.splice(index, 1);
      }
    },

    cartReset() {
      this.product_id.value.value = null;
    },

    async onLeadChange(selectedId) {
      if (!selectedId) {
        this.company_name.value.value = "";
        this.company_email.value.value = "";
        this.company_phone.value.value = "";
        this.contact_name.value.value = "";
        this.contact_designation.value.value = "";
        //this.ref_no.value.value = "";
        this.company_website.value.value = "";
        this.company_address.value.value = "";
        this.company_country_id.value.value = "";
        this.company_nature_of_business.value.value = "";
      }

      try {
        const response = await this.$store.dispatch(
          "getSalesLeadsById",
          selectedId
        );
        this.customer_id.value.value = null;
        const data = response.data;
        this.company_name.value.value = data.company_name || "";
        this.contact_name.value.value = data.contact_name || "";
        this.contact_designation.value.value = data.contact_designation || "";
        this.company_email.value.value = data.company_email || "";
        this.company_phone.value.value = data.company_phone || "";
        this.company_website.value.value = data.company_website || "";
        this.company_address.value.value = data.company_address || "";
        this.company_country_id.value.value = data.company_country_id || "";
        this.company_nature_of_business.value.value =
          data?.company_nature_of_business || "";
        this.$store.commit("UNSET_LOADING");
      } catch (error) {
        console.log(error);
      }
    },
    async onCustomerChange(id) {
      if (!id) {
        this.company_name.value.value = "";
        this.company_email.value.value = "";
        this.company_phone.value.value = "";
        this.contact_name.value.value = "";
        this.contact_designation.value.value = "";
        //this.ref_no.value.value = "";
        this.company_website.value.value = "";
        this.company_address.value.value = "";
        this.company_country_id.value.value = "";
        this.company_nature_of_business.value.value = "";
        return;
      }

      try {
        this.lead_id.value.value = null;
        const customer = await this.$store.dispatch("getCustomerById", id);
        this.$store.commit("SET_LOADING", {color: "primary"});
        this.company_name.value.value = customer?.company_name || "";
        this.contact_name.value.value = customer.contacts ? customer.contacts[0].name : "";
        this.contact_designation.value.value = customer.contacts ? customer.contacts[0].designation : "";
        //this.ref_no.value.value = customer?.ref_no || "";
        this.company_email.value.value = customer?.company_email || "";
        this.company_phone.value.value = customer?.company_mobile || "";
        this.company_website.value.value = customer?.company_website || "";
        this.company_address.value.value = customer?.company_address || "";
        this.company_country_id.value.value = customer?.company_country_id || "";
        this.company_nature_of_business.value.value = customer?.company_business_nature || "";
        this.$store.commit("UNSET_LOADING");
      } catch (error) {
        console.log(error);
      }
    },
  },

  setup() {
    const { proxy } = getCurrentInstance();
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        proposal_date: yup.date().required().label("Purchase Order Date"),
        company_name: yup.string().min(3).max(50).required().label("Company Name"),
        contact_name: yup.string().min(3).max(50).required().label("Contact Name"),
        contact_designation: yup.string().min(2).max(50).required().label("Contact Designation"),
        ref_no: yup.string().min(1).max(50).required().label("Ref no"),
        proposal_status_id: yup.number().required().label("Proposal Status"),
        company_email: yup.string().email().min(3).max(50).required().label("Company Email"),
        company_phone: yup.string().min(7).max(15).required().label("Company Phone Number"),
        company_address: yup.string().min(3).max(400).required().label("Company Address"),
        subject: yup.string().required().label("Letter Subject"),
        discount_flat: yup.string().nullable().label("Discount Flat"),
        company_website: yup.string().nullable().trim().test('is-valid-url','Please enter a valid website URL (e.g. https://example.com)',(value) =>!value || /^https?:\/\/[^\s$.?#].[^\s]*$/i.test(value)),
      }),
    });
    const proposal_master_id = useField("proposal_master_id");
    const product_id = useField("product_id");
    const proposal_status_id = useField("proposal_status_id");
    const pur_order_master_id = useField("pur_order_master_id");
    const lead_id = useField("lead_id");
    const customer_id = useField("customer_id");
    const contact_name = useField("contact_name");
    const contact_designation = useField("contact_designation");
    const ref_no = useField("ref_no");
    const proposal_date = useField("proposal_date");
    const discount_per = useField("discount_per");
    const discount_amount = useField("discount_amount");
    const tax_amount = useField("tax_amount");
    const tax_per = useField("tax_per");
    const tax_type = useField("tax_type");
    const vat_amount = useField("vat_amount");
    const vat_per = useField("vat_per");
    const vat_type = useField("vat_type");
    const total = useField("total");
    const letter_sub = useField("letter_sub");
    const letter_body = useField("letter_body");

    const subject = useField("subject");
    const letter_description = useField("letter_description");

    const remarks = useField("remarks");
    const status = useField("status");
    const company_name = useField("company_name");
    const company_email = useField("company_email");
    const company_phone = useField("company_phone");
    const company_website = useField("company_website");
    const company_address = useField("company_address");
    const company_country_id = useField("company_country_id");
    const company_nature_of_business = useField("company_nature_of_business");
    const next_follow_up_date = useField("next_follow_up_date");
    const follow_up_date = useField("follow_up_date");

    const branch_id = useField("branch_id");
    const errorMessages = ref("");
    const cart = ref([]);
    const loading = ref("");
    const buttonText = ref("");
    buttonText.value = "Save";
    const store = useStore();
    const router = useRouter();

    const currentStatus = ref(0);

    const submitForm = (status) => {
      currentStatus.value = status;
      submit();
    };

    const submit = handleSubmit((values) => {
      if (cart.value.length === 0) {
        toast.error("Cart is required.");
        return;
      }
      values.status = currentStatus.value;
      values.sub_total = proxy.subTotal;

      values.discount_amount = proxy.discountAmount;

      values.tax_amount = proxy.taxAmount;
      values.tax_type = proxy.taxType;

      values.vat_amount = proxy.vatAmount;
      values.vat_type = proxy.vatType;

      values.total = proxy.grandTotal;
      values.cart = cart.value;
      values.proposal_date = formattedDate(proposal_date.value.value);

      values.letter_sub = subject.value.value;
      values.letter_description = letter_description.value.value;
      values.letter_body = letter_body.value.value;


      store
        .dispatch("saveUpdateSalesProposals", values)
        .then((response) => {
          resetForm();
          buttonText.value = "Save";
          cart.value = [];
          toast.success(response.data.message, {
            timeout: 3000,
          });
          setTimeout(() => {
            router.push({ name: "crm-proposal-record" });
          }, 2000);
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        });
    });

    return {
      submitForm,
      submit,
      proposal_master_id,
      proposal_status_id,
      cart,
      proposal_date,
      product_id,
      pur_order_master_id,
      lead_id,
      customer_id,
      discount_per,
      discount_amount,
      tax_amount,
      tax_per,
      tax_type,
      vat_amount,
      vat_per,
      vat_type,
      ref_no,
      total,
      contact_name,
      letter_sub,
      subject,
      letter_description,
      letter_body,
      branch_id,
      remarks,
      status,
      company_name,
      contact_designation,
      company_email,
      company_phone,
      company_website,
      company_address,
      company_country_id,
      company_nature_of_business,
      next_follow_up_date,
      follow_up_date,
      buttonText,
      ClassicEditor,
      errorMessages,
      loading,
    };
  },

  mounted() {
    // if (this.$store.getters.getPurLetterInfo) {
      this.$store.dispatch("getPurLetterInfo").then(() => {
        this.setLetterData();
      });
    // }

    const id = this.$route.query.id;
    if (id) {
      this.$store.commit("SET_LOADING", { color: "primary" });

      this.$nextTick(() => {
        this.$store
          .dispatch("getSalesProposalbyId", id)
          .then((data) => {
            this.isEntryMode = false;
            let leadData = data;
            this.proposal_master_id.value.value = leadData?.id;
            this.lead_id.value.value = leadData?.lead?.id;
            this.customer_id.value.value = leadData?.customer?.id;
            this.proposal_status_id.value.value = leadData?.proposal_status_id;
            this.proposal_date.value.value = leadData.proposal_date ? new Date(leadData.proposal_date): new Date();
            this.company_name.value.value = leadData.company_name;
            this.contact_name.value.value = leadData.contact_name;
            this.contact_designation.value.value = leadData.contact_designation;
            this.ref_no.value.value = leadData.ref_no;
            this.company_email.value.value = leadData.company_email;
            this.company_nature_of_business.value.value = leadData.company_nature_of_business;
            this.company_phone.value.value = leadData.company_phone;
            this.company_address.value.value = leadData.company_address;
            this.company_country_id.value.value = leadData.company_country_id;
            this.discount_per.value.value = Number(leadData.discount_per);
            this.tax_per.value.value = Number(leadData.tax_per);
            this.vat_per.value.value = Number(leadData.vat_per);
            this.subject.value.value = leadData.letter_sub;
            this.letter_description.value.value = leadData.letter_description;
            this.letter_body.value.value = leadData.letter_body;
            (this.status.value.value = 1);
            (this.cart.value = []);

            (leadData.details || []).forEach((item) => {
              this.cart.push({
                product_id: item.product_id,
                product_name: item.product?.name || "",
                qty: Number(item.qty),
                unit_id: item.product.unit?.id || "",
                unit_name: item.product.unit?.name || "",
                purchase_rate: Number(item.purchase_rate),
                sale_rate: Number(item.sale_rate),
                total: Number(item.qty * item.sale_rate),
              });
            });
            this.remarks.value.value = leadData.remarks ? leadData.remarks : "";
            this.$store.commit("UNSET_LOADING");
          })
          .catch((error) => {
            this.$store.commit("UNSET_LOADING");
            console.error("Failed to fetch lead:", error);
          });
      });
    } else {
      this.isEntryMode = true;
      this.lead_id.value.value = null;
      this.proposal_date.value.value = new Date();
    }
  },
};
</script>
  